// extracted by mini-css-extract-plugin
module.exports = {"submit":"SubmitButton-module--submit--3yCAc"};